import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment.model';

import { AutoSuggestProfile } from '../../shared/models/autoSuggest.model';

@Injectable({
  providedIn: 'root',
})
export class AutoSuggestService {
  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  autoSuggestProfiles(searchtext: unknown) {
    return this.http.get<AutoSuggestProfile>(
      `${this.env.API_BASE_URL + '/service/authorization'}/secure/userprofile/search?searchText=${searchtext}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }
}
